export const GRAPH_PER_WEEK_WIDTH = 56;
export const TOTAL_MEMBERS_BAR_WIDTH = 412;
